module.exports = __webpack_public_path__ + "static/media/the-culture-works.945493cf.png";